// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Popover-cls1__bf04b9ddb146f331ace1{/*!*/}.Popover-cls2___f0769b3bbfe5f4c9d28{position:absolute;top:0;left:0;display:flex;flex-direction:column;width:-moz-max-content;width:max-content;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Popover-cls1__bf04b9ddb146f331ace1",
	"cls2": "Popover-cls2___f0769b3bbfe5f4c9d28 Popover-cls1__bf04b9ddb146f331ace1"
};
export default ___CSS_LOADER_EXPORT___;
